module.exports = __webpack_public_path__ + "img/hertford_b4.4bd40e32.jpg";